import { ReceiptModelAPI } from '~/services/receipt-model-api/receipt-model-api.types';

import {
  TRANSFER_CATEGORY_MAP,
  TRANSFER_KIND_MAP,
  TRANSFER_RECIPIENT_MAP,
  TRANSFER_STATUS_COLOR_MAP,
  TRANSFER_STATUS_MAP,
} from '../constants';

export default function useTransferFormatters() {
  function formatCategory(category: ReceiptModelAPI.TransferCategory): string {
    return TRANSFER_CATEGORY_MAP[category as keyof typeof TRANSFER_CATEGORY_MAP] || category;
  }

  function formatRecipient(recipient: ReceiptModelAPI.TransferRecipient): string {
    return TRANSFER_RECIPIENT_MAP[recipient as keyof typeof TRANSFER_RECIPIENT_MAP] || recipient;
  }

  function formatKind(kind: ReceiptModelAPI.TransferKind): string {
    return TRANSFER_KIND_MAP[kind as keyof typeof TRANSFER_KIND_MAP] || kind;
  }

  function formatStatus(status: ReceiptModelAPI.TransferStatus): string {
    return TRANSFER_STATUS_MAP[status as keyof typeof TRANSFER_STATUS_MAP] || status;
  }

  function getStatusColor(status: ReceiptModelAPI.TransferStatus): string {
    return TRANSFER_STATUS_COLOR_MAP[status as keyof typeof TRANSFER_STATUS_COLOR_MAP] || 'secondary';
  }

  return {
    formatCategory,
    formatKind,
    formatRecipient,
    formatStatus,
    getStatusColor,
  };
}
